"use client";
// List of extras Services Cleaning Categories Landing Pages;
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import * as v1Api from "../../services/api";
import { ExtraService } from "../BookingApp/interfaces";
import ExtrasCounterCard from "../BookingApp/ExtrasCard/ExtrasCard";

function ExtrasServicesCLP() {
  const router = useRouter();
  const [extras, setExtras] = useState<ExtraService[]>([]);

  useEffect(() => {
    const loadServices = async () => {
      if (!router.isReady) return;

      const category = router.query.page?.[0];

      try {
        const data = await v1Api.fetchExtraServices("1", category);
        setExtras(data);
      } catch (error) {
        console.log("Error Loading Extras Services:", error);
      }
    };
    loadServices();
  }, [router.isReady, router.query]);

  // const extras = availableExtras;
  const numColumns = 4;

  return (
    <div>
      <div className="mx-auto my-12">
        <div className={`grid grid-cols-2 md:grid-cols-${numColumns} gap-4`}>
          { extras && extras.map((extra) => (
              <div
              key={extra.extra_id}
              className="flex flex-col mb-4 rounded-lg py-4 pr-2 max-w-3xl mx-auto border border-[#8C6F34] bg-white text-[12px] w-full"
            >
              <div className="px-6">
                <div className="flex justify-between items-center">
                  <span>{extra.name}</span>
                  <span className="font-bold">$ {extra.per_cost}</span>
                </div>
                <div className="mt-2 pt-1 border-t border-[#8C6F34]">
                  <span>{extra.description}</span>
                </div>
              </div>
            </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default ExtrasServicesCLP;
